import { readonly, ref } from "vue";

interface Branch {
	BranchID: number
	BranchKeyword: string
	BranchName: string
	color: string
	warehouseid?: string
}

const branches = ref<Branch[]>([])

const fetchBranches = async () => {
	const response = await fetch(`${api_base_url}/api/branch`)
	const json = await response.json()

	branches.value = json
}

export {
	fetchBranches as setup,
}
export const useBranches = () => readonly(branches)
